import {Action} from '@ngrx/store';

export const GET_CONFIG = '[CONFIG] GET';
export const GET_CONFIG_SUCCESS = '[CONFIG] GET_SUCCESS';
export const GET_CONFIG_FAIL = '[CONFIG] GET_FAIL';

export class GetConfig implements Action {
  readonly type = GET_CONFIG;
}

export class GetConfigSuccess implements Action {
  readonly type = GET_CONFIG_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetConfigFail implements Action {
  readonly type = GET_CONFIG_FAIL;

  constructor(public payload: any) {
  }
}

export type ConfigAction =
  GetConfig
  | GetConfigSuccess
  | GetConfigFail;



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/store/actions/config.action.ts